export const MENU = {
  SCROLL_TO_VIEW:{
    MAIN: 'SCROLL_TO_VIEW',
    SUCCESS: 'SCROLL_TO_VIEW_SUCCESS',
    FAILURE: 'SCROLL_TO_VIEW_FAILURE'
  }
}
